import React from "react";

import Preview, { PreviewType } from "modules/common/components/authoring/dialogs/preview";
import { ISMS } from "./models";
import PreviewPhone from "./previewPhone";
import { DEFAULT_SMS } from "./reducer";

interface ISMSPreviewProps {
    show: boolean;
    onClose: () => void;
    sms: ISMS;
}

const SMSPreview: React.FC<ISMSPreviewProps> = ({
    show,
    onClose,
    sms,
}) => {
    const getPreviewPhone = () => {
        return <PreviewPhone
            phoneNumber={sms.fromNumber ?? DEFAULT_SMS.fromNumber!}
            previewTextMessage={sms.plainBody}
            drawerOpenPadding={false}
            showDisclaimer={false}
            overrideWidth="40%"
        />
    }

    return <Preview
        onClose={onClose}
        open={show}
        previews={[{ type: PreviewType.Plain, component: getPreviewPhone(), label: "DESKTOP" }]}
        previewHelpText="Actual SMS appearance varies per recipient and device."
    />;
};

export default SMSPreview;
